module.exports = __webpack_public_path__ + "static/media/blackIcon.fe97d2b6.png";